import { createTheme } from "@mui/material/styles";

const dataEntries = createTheme({
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					padding: "6px 12px !important",
					fontSize: "0.7rem !important",
					borderRadius: 4,
					lineHeight: 1.5,
					minHeight: "35px",
				},
			},
		},
		MuiButtonGroup: {
			styleOverrides: {
				grouped: {
					minWidth: 30,
				},
			},
		},
		MuiTextField: {
			styleOverrides: {
				root: {
					"& .MuiInputBase-root": {
						// Remove fixed height for multiline
						minHeight: "35px !important",
						padding: "4px 20px 4px 5px !important",
					},
					"& .MuiOutlinedInput-input": {
						padding: "4px 0px 4px 4px !important",
						fontSize: "0.8rem !important",
					},
					"& label": {
						fontSize: "0.8rem !important",
					},
					// Add styles for multiline input
					"& .MuiOutlinedInput-multiline": {
						padding: "8px 14px !important",
					},
				},
			},
		},
		// New table-related styles
		MuiTable: {
			styleOverrides: {
				root: {
					minWidth: 300,
				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {
					padding: 4,
					"&.narrow": {
						whiteSpace: "nowrap",
						maxWidth: "80px",
					},
				},
				head: {
					fontWeight: "bold",
				},
			},
		},
		MuiTableRow: {
			styleOverrides: {
				root: {
					"&:nth-of-type(odd)": {
						backgroundColor: "#f5f5f5 !important",
					},
				},
			},
		},

		MuiFormControl: {
			styleOverrides: {
				root: {
					margin: "2px 0",
					width: "100%", // Ensure it takes full width of its container
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				outlined: {
					fontSize: "0.8rem !important",
					transform: "translate(14px, 12px) scale(1)",
					"&.MuiInputLabel-shrink": {
						transform: "translate(14px, -6px) scale(0.75)",
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					height: "35px",
				},
				input: {
					padding: "8px 14px !important",
					height: "19px !important",
					fontSize: "0.7rem !important",
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				select: {
					height: "35px !important",
					lineHeight: "35px !important",
					paddingTop: 0,
					paddingBottom: 0,
					fontSize: "0.8rem !important",
				},
				outlined: {
					paddingRight: "32px !important", // Space for the dropdown icon
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					fontSize: "0.8rem",
					minHeight: "35px",
					lineHeight: "35px !important",
				},
			},
		},
	},
});

export default dataEntries;
